import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/ent"
// 增值税发票综合服务平台
// let localPrefix = "localdisk"

export function findByUserRole() {
  return request({
    url: prefix + '/findByUserRole',
    method: 'get'
  })
}

export function findByOrgId(orgId) {
  return request({
    url: prefix + '/findByOrgId/' + orgId,
    method: 'get'
  })
}

export function findByUser() {
  return request({
    url: prefix + '/findByUser',
    method: 'get'
  })
}

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}

export function deleteEnt(id) {
  return request({
    url: prefix + '/delete/' + id,
    method: 'get'
  })
}

export function verificateEnt(id) {
  return request({
    url: prefix + '/verificate/' + id,
    method: 'get'
  })
}

export function addEnt(entDto) {
  return request({
    url: prefix + '/add',
    method: 'post',
    data: entDto,
  })
}

export function enableEnt(id) {
  return request({
    url: prefix + '/enable/' + id,
    method: 'get'
  })
}

export function disableEnt(id) {
  return request({
    url: prefix + '/disable/' + id,
    method: 'get'
  })
}
